__turbopack_context__.v({
  "buttonGroup": "ProductLineCarousel-module-scss-module__9PaquW__buttonGroup",
  "container": "ProductLineCarousel-module-scss-module__9PaquW__container",
  "header": "ProductLineCarousel-module-scss-module__9PaquW__header",
  "heading": "ProductLineCarousel-module-scss-module__9PaquW__heading",
  "navButton": "ProductLineCarousel-module-scss-module__9PaquW__navButton",
  "root": "ProductLineCarousel-module-scss-module__9PaquW__root",
  "slide": "ProductLineCarousel-module-scss-module__9PaquW__slide",
  "swiper": "ProductLineCarousel-module-scss-module__9PaquW__swiper",
});
